import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { wfApi } from '../../api/workflow.js';
import { useAuth } from '../../contexts/AuthContext.jsx';

export default function WorkflowDefinitions() {
  const { can } = useAuth();
  const canCreate = can('workflow_definition', 'create');
  const [items, setItems] = useState([]);

  function refresh() { wfApi.listDefinitions().then((d) => setItems(d?.items || [])); }
  useEffect(refresh, []);

  async function toggle(d) {
    if (d.is_active) await wfApi.deactivateDefinition(d.id);
    else await wfApi.activateDefinition(d.id);
    refresh();
  }

  return (
    <section>
      <header className="page-header">
        <h1>Workflow Definitions</h1>
        {canCreate && <Link to="/workflows/definitions/new" className="btn primary">+ New Workflow</Link>}
      </header>
      <div className="card">
        <table className="data-table">
          <thead><tr><th>Resource</th><th>Name</th><th>Version</th><th>Active</th><th></th></tr></thead>
          <tbody>
            {items.map((d) => (
              <tr key={d.id}>
                <td><code>{d.trigger_resource}</code></td>
                <td><Link to={`/workflows/definitions/${d.id}`}>{d.name}</Link></td>
                <td>v{d.version}</td>
                <td>
                  {canCreate ? (
                    <label className="switch">
                      <input type="checkbox" checked={d.is_active} onChange={() => toggle(d)} />
                      <span />
                    </label>
                  ) : (
                    <span className={`chip status-${d.is_active ? 'active' : 'cancelled'}`}>{d.is_active ? 'active' : 'inactive'}</span>
                  )}
                </td>
                <td><Link to={`/workflows/definitions/${d.id}`} className="btn ghost small">Open</Link></td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={5} className="muted">No workflows configured.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
